import { authHeader } from '../helpers';

export const userService = {
  getHomeData,
  getPastConcerts,
  getConcerts,
  getConcert,
  getArtists,
  getNewsListing,
  getNews,
  getPressData,
  getAboutData,
  getFAQ,
  getUsefulContacts,
  getSponsors,
  getContactData,
  getDonationData,
  getPressFormData,
  getPressInnerData,
  getSearchResults,
  getSettingsData,
  getMetaData,
};

// Prod
export const API_URL = 'https://cms.2021.inclassica.com/api';

// Dev
// export const API_URL = 'https://api.inclassica.codics.solutions/api';

const requestOptions = {
  method: 'GET',
  headers: authHeader(),
};

function getMetaData (page) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/metas/${page}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getHomeData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/home`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getAboutData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/about`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getConcerts (status = 'upcoming') {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${API_URL}/concerts?status=${status}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getPastConcerts (status = 'past') {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${API_URL}/concerts?status=${status}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getConcert (path) {
  const url = path.replace('/calendar/', '');
  return fetch(`${API_URL}/concerts/${url}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getContactData () {
  return fetch(`${API_URL}/official/contacts`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getArtists () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/artists`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getFAQ () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/faqs`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getUsefulContacts () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/contacts`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getSettingsData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/settings`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getSponsors () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/partners`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getNewsListing (pageNum = 1, limit = 10) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/news?page=${pageNum}&limit=${limit}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getNews (path) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  const url = path.replace('/news/', '');
  return fetch(`${API_URL}/news/${url}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getPressData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/gallery`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getPressInnerData (path) {
  const id = path.replace('/press/', '');
  // .replace(`${path.substring(path.lastIndexOf('/') + 1)}`, '')
  // .replace('/', '');
  // console.log(id, 'hello');

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/gallery/${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getDonationData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/donation`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getPressFormData () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${API_URL}/accreditation`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function getSearchResults (search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${API_URL}/elastic/search${search}`,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      return res.data;
    });
}

function handleResponse (response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 422) {
        const error = (data && data.errors.email[0]) || response.statusText;
        return Promise.reject(error);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    const token =
      response.headers.get('Authorization') &&
      response.headers.get('Authorization');
    const date = response.headers.get('server_date');
    return {
      data,
      token,
      date,
    };
  });
}
